export default __webpack_public_path__ + "static/univers-black-7e29fc46bf8a8d0575e8ae2665b7428a.woff2";